import React, {Fragment, useEffect, useRef, useState} from "react";
import {Chart, Axis, Tooltip,Annotation, Line, GComponents, Schema, Legend} from 'bizcharts';
import {connect} from "react-redux";
import {getIndicators} from "../../../actions/IndicatorsActions";
import Spinner from "../../common/Spinner";
// import Plot from 'react-plotly.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Carousel} from "react-bootstrap";
import SingleSlidePlot from "./SingleSlidePLot";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import {PlotCarousel} from "./index";
import {
    clearData,
    clearPrevious,
    removePlotPoint,
    deletePreviousFilter,
    setActivePlot,
    getData, getHospital
} from "../../../actions";
import {DataView} from '@antv/data-set';
import Interaction from "bizcharts/es/components/Interaction";
import { UncontrolledTooltip, CardTitle, CardBody } from "reactstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";


const {
    Canvas,
} = GComponents;

const UnloggedPlot = ({PlotData: {plot_data, loading, hide_data, stats, active_plot, refresh}, getData, clearData, deletePreviousFilter, clearPrevious,getHospital, Filters: {start_date,end_date,active_filter, refresh_filter,previous_filter}, removePlotPoint, setActivePlot, Indicators: {available_indicators,active_indicators}}) => {
    const [displayData, SetData] = useState([]);
    const [index, setIndex] = useState(0);
    const dv = useRef(null)
    const [toolTipText, setTooltip] = useState('')
    const [scaleData, setScale] = useState({
        nazwa_regionu: {
            sync: true,
        },
        "range": {

            max: 10,
            min: -10,
            nice: "true"
        },
        "wartosc_wskaznika":{
            max: 10,
            min: -10,
                }
    });
    const getDataRuqest = () => {


        getData(active_indicators, previous_filter,start_date,end_date);

        if (active_indicators.length !== Object.keys(plot_data).length) {
            let keys = Object.keys(plot_data);
            let difference = keys.filter(x => !active_indicators.includes(x));
            difference.map(x => {
                deletePreviousFilter(x,"none","up62");
                removePlotPoint(x)
            });


        }
    }
    useEffect(() => {
        if (active_indicators.length !== 0 && (active_indicators.length > Object.keys(plot_data).length)) {
            getDataRuqest()
        }


        if (active_indicators.length === 0) {
            clearData();
            clearPrevious();
            SetData([]);
        }


    }, [active_indicators]);
    useEffect(() => {getDataRuqest()},[start_date,end_date]);
    useEffect(() => {
        if (active_indicators.length !== 0 && (active_indicators.length === Object.keys(plot_data).length)) {
            getDataRuqest()

        }


    }, [active_filter,refresh_filter]);
    useEffect(() => {getHospital();},[])
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    useEffect(() => {
        if (displayData.length !== Object.keys(plot_data).length && displayData.length !== 0) {
            let keys = Object.keys(plot_data);
            // let difference = displayData.filter(x => !keys.includes(x));
        }

    }, [displayData]);


    useEffect(() => {
        if (active_indicators.length !== Object.keys(plot_data).length) {
            let keys = Object.keys(plot_data);
            let difference = keys.filter(x => !active_indicators.includes(x));
            if (difference.includes(Object.keys(plot_data)[index])) {
                setIndex(0)
                setActivePlot(Object.keys(plot_data)[0]);
            }
        } else
            setActivePlot(Object.keys(plot_data)[index]);
    }, [index, plot_data]);
    useEffect(() => {
        // SetData(plot_data.filter(dataPoint => !hide_data.includes(dataPoint.nazwa_regionu)))
        if (!hide_data.hasOwnProperty(active_plot) || !plot_data.hasOwnProperty(active_plot)) {

            if (index === Object.keys(plot_data).length && Object.keys(plot_data).length !== 0) {
                setIndex(index - 1);
            }
            return;
        }

        const filtered = {...Object.keys(plot_data)};
        filtered[active_plot] = calculateData();
        scaleCharts(filtered[active_plot]);

        SetData(filtered);

        if (index === Object.keys(plot_data).length && Object.keys(plot_data).length !== 0) {
            setIndex(index - 1);
        }
        setTooltip(available_indicators.filter(available=>available.nazwa === active_plot)[0].opis)
    }, [plot_data, hide_data, refresh, active_plot, active_indicators]);


    // Filtrowanie danych do wyświetlania a następnie wyliczanie danych statystycznych na ich podstawie
    const calculateData = () => {
        let data = plot_data[active_plot].filter(key => !hide_data[active_plot].includes(key.nazwa_regionu));
        data = data.filter(x => !active_indicators.includes(x));

        const d = new DataView().source(data)

        d.transform({
                type: 'map',
                callback: obj => {

                    obj.range = [obj.low, obj.q1, obj.median, obj.q3, obj.high];
                    return obj;
                }
            }
        )
        return d.rows;
    };
    // Sortowanie danych potrzebne do wyliacznia kwartyli
    const asc = arr => arr.sort((a, b) => a - b);
    // Funkcja wyliczjaca kwartyle
    const quantile = (arr, q) => {
        const sorted = asc(arr);
        const pos = (sorted.length - 1) * q;
        const base = Math.floor(pos);
        const rest = pos - base;
        if (sorted[base + 1] !== undefined) {
            return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
        } else {
            return sorted[base];
        }
    };

    // Ustwainie osi y dla danych statysnczych w zależnosci od wartości wskaźników
    const scaleCharts = (data) => {
        let valuesMAXArray = data.map(item => item.high);
        let valuesMINArray = data.map(item => item.low);
        if (valuesMAXArray.length !== 0) {
            setScale({
                nazwa_regionu: {
                    sync: true
                },
                "range": {
                    min: valuesMINArray.reduce((prev, curr) => prev < curr ? prev : curr)*1.1,
                    max: valuesMAXArray.reduce((prev, curr) => prev > curr ? prev : curr)*1.1,

                },
                "wartosc_wskaznika":{
                    min: valuesMINArray.reduce((prev, curr) => prev < curr ? prev : curr)*1.1,
                    max: valuesMAXArray.reduce((prev, curr) => prev > curr ? prev : curr)*1.1,
                    alias: "Wartość wskaźnika dla twojego szpitala",
                }
            })
        }
    };
    let chartIns = null;
    return (<Fragment>{!loading ? <Carousel activeIndex={index} onSelect={handleSelect} interval={null}
                                            nextIcon={<span aria-hidden="true" className="carousel-control-next-icon"
                                                            style={style_next}/>}
                                            prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon"
                                                            style={style_prev}/>}>


            {Object.keys(displayData).length > 0 && Object.keys(plot_data).map((key, id) =>
                <Carousel.Item key={key} className={"justify-content-center"}>
                    <Container className={'justify-content-center'}>
                         <h4 id={"inidcator_title"} className="mr-3 ml-3">{key} {index + 1}/{Object.keys(plot_data).length}</h4>
                        <UncontrolledTooltip  placement="left" target="inidcator_title" delay={0}>

                            {toolTipText}
                        </UncontrolledTooltip >


                        <Container className={'ml-4'}>
                            <Chart ref={dv} height={"55vh"} width={"90%"} autoFit
                                   data={displayData[key]}
                                   interactions={['active-region']}
                                   padding={[70, 70, 70, 70]}
                                   scale={scaleData}

                                   onGetG2Instance={(chart) => {
                                       chartIns = chart;
                                   }}

                            >
                                <Axis name={"nazwa_regionu"} label={{ rotate: 0.5, autoRotate: true, style: {textAlign: 'start', fontSize: 10 } }}/>
                                <Axis name={"wartosc_wskaznika"}/>
                                <Axis name={"range"}/>
                                <Tooltip
                                    showTitle={false}
                                    showMarkers={false}
                                    itemTpl={'<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;">'
                                    + '<span style="background-color:{color};" class="g2-tooltip-marker"></span>'
                                    + '{name}<br/>'
                                    + '<span style="padding-left: 16px">MAX：{high}</span><br/>'
                                    + '<span style="padding-left: 16px">Górny：{q3}</span><br/>'
                                    + '<span style="padding-left: 16px">MEDIANA：{median}</span><br/>'
                                    + '<span style="padding-left: 16px">DOLNY：{q1}</span><br/>'
                                    + '<span style="padding-left: 16px">MIN：{low}</span><br/>'
                                    + '<span style="padding-left: 16px">Wartość twojej jednostki：{wartosc_wskaznika}</span><br/>'
                                    + '</li>'}
                                />

                                <Legend visible={true}/>
                                  <Line  position="nazwa_regionu*wartosc_wskaznika"
                                          color={"pink"}
                                         tooltip="false"

                                  />
                                <Schema
                                    position={'nazwa_regionu*range'}
                                    shape={'box'}
                                    style={{
                                        stroke: '#545454',
                                        fill: '#2ba9cd',
                                        fillOpacity: 1
                                    }}
                                    scale={scaleData}
                                    tooltip={[
                                        'nazwa_regionu*low*median*q3*q1*high*wartosc_wskaznika',
                                        (nazwa_regionu, low, median, q3, q1, high,wartosc_wskaznika) => {
                                            return {
                                                name: nazwa_regionu,
                                                low,
                                                q1,
                                                median,
                                                q3,
                                                high,
                                                wartosc_wskaznika
                                            };
                                        }
                                    ]}


                                />


                            </Chart>
                        </Container>
                    </Container>

                </Carousel.Item>
            )}


        </Carousel> : <Card>
            <CardTitle tag="h4">Wybierz wskaźniki, aby narysować wykres</CardTitle>
            <CardBody><Spinner/></CardBody>
        </Card>}
            {active_indicators.length > 3 ? <PlotCarousel index={index} setIndex={setIndex}/> : <> </>}
        </Fragment>

    )

};
const style_next = {
    "backgroundImage": `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e")`

};

const style_prev = {

    "backgroundImage": `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%20300' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E")`

};
// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Indicators: state.Indicators,
    Filters: state.Filters,

});


export default connect(mapStateToProps, {
    setActivePlot,
    clearData,
    getData,
    deletePreviousFilter,
    removePlotPoint,
    clearPrevious,
    getHospital
})(UnloggedPlot);


